<template>
  <el-date-picker
    :style="{width}"
    v-model="value"
    :picker-options="isShowPicker?pickerOptions:{}"
    :default-time="['00:00:00', '23:59:59']"
    type="datetimerange"
    value-format="yyyy-MM-dd HH:mm:ss"
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    align="right"
    @change="change"
  />
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    start: {
      type: [String, Number],
      default: null
    },
    end: {
      type: [String, Number],
      default: null
    },
    isShowPicker: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: this.start ? [this.start, this.end] : [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            console.log(start, end)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  watch: {
    start: {
      handler(value) {
        console.log(value)
        if (!value) {
          this.value = []
        } else {
          this.value = this.start ? [this.start, this.end] : []
        }
      }
    },
    value: {
      handler(value) {
        console.log(value)
        if (value) {
          this.$emit('update:start', value[0])
          this.$emit('update:end', value[1])
        } else {
          this.$emit('update:start', null)
          this.$emit('update:end', null)
        }
      }
    }
  },
  methods: {
    change(e) {
      this.$emit('change', e)
    }
  }
}
</script>

<style lang="less" scoped>
:deep{
  .el-range-separator{
    min-width: 20px;
  }
}
</style>
